export interface Deposito {
  idDeposito: number;
  nombre: string;
  idDireccion: number | null;
  direccionDescripcion?: string;
  cantidadUbicaciones?: number;
}

export interface Ubicacion {
  idUbicacion: number;
  idDeposito: number;
  descripcion: string;
}

export const initialDepositoState: Deposito = {
  idDeposito: 0,
  nombre: '',
  idDireccion: null,
};

export const initialUbicacionState: Ubicacion = {
  idUbicacion: 0,
  idDeposito: 0,
  descripcion: '',
};
